/**
 * @license lucide-vue-next v0.577.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createLucideIcon from '../createLucideIcon.js';

const ZodiacAries = createLucideIcon("zodiac-aries", [
  ["path", { d: "M12 7.5a4.5 4.5 0 1 1 5 4.5", key: "k987hv" }],
  ["path", { d: "M7 12a4.5 4.5 0 1 1 5-4.5V21", key: "mjup0w" }]
]);

export { ZodiacAries as default };
//# sourceMappingURL=zodiac-aries.js.map
